






































import { Component, Mixins } from "vue-property-decorator";
import InfiniteLoading from "vue-infinite-loading";
import { DocumentSummary } from "../../../../../domain/document";
import { DocumentSelectorMixin } from "../../mixins";

@Component({
  components: {
    InfiniteLoading,
  }
})
export default class DocumentSelectorCardStyle extends Mixins(DocumentSelectorMixin) {
  createDateTimeText(row: DocumentSummary): string {
    return this.toDateString(row.contentDateTime) + " " + this.toTimeString(row.contentDateTime);
  }

  onSelectionChanged(row: DocumentSummary) {
    this.input(row);
  }
}
